export const createCourtDocketPayload = (fiedSettings, visibleFieldSettings, columnWidths) => {
	const courtDocketFieldSettings = [];
	let globalOrder = 1;
	fiedSettings.forEach((element, index) => {
		if (element.type === 'folder') {
			if (element.children && element.children.length > 0) {
				element.children.forEach((child, childIdx) => {
					courtDocketFieldSettings.push({
						orderNumber: globalOrder++,
						label: child.label,
						name: child.name,
						groupName: element.label,
						groupOrder: index + 1,
						groupId: Number(element.id),
						columnWidth: columnWidths[child.name]?.columnWidth || 0,
						visible: visibleFieldSettings[child.name]
					});
				});
			}
		} else {
			courtDocketFieldSettings.push({
				orderNumber: globalOrder++,
				label: element.label,
				name: element.name,
				groupId: null,
				columnWidth: columnWidths[element.name]?.columnWidth || 0,
				visible: visibleFieldSettings[element.name]
			});
		}
	});

	return {
		districtAttorneyOrCountyAttorney: visibleFieldSettings.districtAttorneyOrCountyAttorney,
		hideDocketTitle: visibleFieldSettings.hideDocketTitle,
		hideDocketEndTime: visibleFieldSettings.hideDocketEndTime,
		courtDocketFieldOrder: courtDocketFieldSettings
	};
};

export const createPublicCalendarPayload = (fiedSettings, visibleFieldSettings, columnWidths) => {
	const publicCalendarFieldSettings = [];
	let globalOrder = 1;
	fiedSettings.forEach((element, index) => {
		if (element.type === 'folder') {
			if (element.children && element.children.length > 0) {
				element.children.forEach((child, childIdx) => {
					publicCalendarFieldSettings.push({
						orderNumber: globalOrder++,
						label: child.label,
						fieldName: child.name,
						groupOrder: index + 1,
						groupId: Number(element.id),
						visible: visibleFieldSettings[child.name],
						columnWidth: columnWidths[child.name]?.columnWidth || 0
					});
				});
			}
		} else {
			publicCalendarFieldSettings.push({
				orderNumber: globalOrder++,
				label: element.label,
				fieldName: element.name,
				groupId: null,
				visible: visibleFieldSettings[element.name],
				columnWidth: columnWidths[element.name]?.columnWidth || 0
			});
		}
	});

	return {
		allowPublicView: visibleFieldSettings.allowPublicView,
		allowPublicPrint: visibleFieldSettings.allowPublicPrint,
		courtSealImage: visibleFieldSettings.courtSealImage,
		fields: publicCalendarFieldSettings
	};
};
